import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee } from './components/Guarantee';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-text selection:bg-brand-mint/30" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Solution data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <WhoItsFor data-id="element-5" />
      <Guarantee data-id="element-6" />
      <Pricing data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}